<template>
    <div class="generate_step">
        <h3>Generating</h3>
        <p>Our deep learning algorithms and expert technologists are now busy generating your website for <b>{{name}}</b> based on the information you provided</p>
        <p class="warning_note">This process is expected to take a <b>minimum of 48hrs</b></p>
        <img src="/img/loader_hud.svg" class="loader_hud" />
        <p class="margin_bottom">You will be <b>notified by email</b> and within the system when the website is online</p>
        <md-button class="md-success md-raised" @click="$emit('done')" style="margin-left: -21px;">Ok</md-button>
    </div>
</template>

<script>
    export default {
        name: 'BuildingGenerating',
        props: {
            name:null,
        }
    }
</script>

<style lang="scss">
 
</style>
